import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import type { ImportResponse } from '../../types'
import {
  ActionButtons,
  DropZone,
  ErrorAlert,
  FormatHelp,
  SuccessResult,
} from './license-criteria-import-form/license-criteria-import-form.parts'
import { useLicenseCriteriaImportForm } from './license-criteria-import-form/use-license-criteria-import-form'

interface LicenseCriteriaImportFormProps {
  onSuccess?: (result: ImportResponse) => void
  onError?: (error: Error) => void
}

export function LicenseCriteriaImportForm(props: LicenseCriteriaImportFormProps): ReactElement {
  const { onSuccess, onError } = props
  const { t } = useTranslation('admin')
  const state = useLicenseCriteriaImportForm({ onSuccess, onError, t })

  return (
    <div className="rounded-xl border border-stone-200 bg-white p-6 shadow-sm dark:border-stone-700 dark:bg-stone-800">
      <h3 className="mb-4 text-lg font-semibold text-stone-900 dark:text-white">
        {t('licensing.importCriteria')}
      </h3>
      <p className="mb-4 text-sm text-stone-600 dark:text-stone-400">
        {t('licensing.importCriteriaDescription')}
      </p>
      <DropZone
        isDragging={state.isDragging}
        selectedFile={state.selectedFile}
        fileInputRef={state.fileInputRef}
        onDragOver={state.handleDragOver}
        onDragLeave={state.handleDragLeave}
        onDrop={state.handleDrop}
        onFileSelect={state.handleFileSelect}
        t={t}
      />
      <ActionButtons
        selectedFile={state.selectedFile}
        isUploading={state.isUploading}
        onUpload={() => {
          void state.handleUpload()
        }}
        onClear={state.handleClear}
        t={t}
      />
      {state.error !== null && <ErrorAlert message={state.error} />}
      {state.result && <SuccessResult result={state.result} t={t} />}
      <FormatHelp t={t} />
    </div>
  )
}
